/**
 * @description 配置托管中心 uclConfig
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const uclConfigBiz = new Logic()

uclConfigBiz.getEnvList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.uclConfig.getEnvList,
    data: data
  }, true)
}

uclConfigBiz.addEnv = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.uclConfig.addEnv,
    data: data
  })
}

uclConfigBiz.editEnv = function (data, id) {
  return this.ajax({
    ...this.REQUEST_OPT.uclConfig.editEnv,
    url: `/api/env/update/${id}`,
    data: data
  }, true)
}

uclConfigBiz.deleteEnv = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.uclConfig.deleteEnv,
    data: data
  })
}

uclConfigBiz.getVersionList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.uclConfig.getVersionList,
    data: data
  }, true)
}

uclConfigBiz.getConfigList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.uclConfig.getConfigList,
    data: data
  }, true)
}

uclConfigBiz.checkContent = function (data) {
  return this.ajax({
    url: `/api/web/config/${data.id}`,
    json: false,
    data: data,
    method: 'get',
    auth: true
  }, true)
}

uclConfigBiz.deleteConfig = function (data) {
  return this.ajax({
    url: `/api/web/config/${data}`,
    auth: true,
    method: 'delete'
  })
}

uclConfigBiz.addConfig = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.uclConfig.addConfig,
    data: data
  })
}

uclConfigBiz.multiDownload = function (data) {
  window.open(`/api/web/config/downloadfilebatch?appId=${data.appId}&envId=${data.envId}&version=${data.version}`)
}

uclConfigBiz.singleDownload = function (data) {
  window.open(`/api/web/config/download/${data}`)
}

uclConfigBiz.updateFile = function (data, id) {
  return this.ajax({
    ...this.REQUEST_OPT.uclConfig.updateFile,
    url: `/api/web/config/filetext/${id}`,
    data: data
  }, true)
}

uclConfigBiz.uploadFile = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.uclConfig.uploadFile,
    data: data
  })
}

uclConfigBiz.clone = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.uclConfig.clone,
    data: data
  }, true)
}
export default uclConfigBiz
